//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { email, required, minLength } from "vuelidate/lib/validators";

export default {
	name: "register",
	data: () => ({
		email: "",
		login: "",
		password: "",
		passIsActive: false,
		loginIsActive: false,
		emailIsActive: false,
	}),
	validations: {
		email: { email, required },
		login: { required, minLength: minLength(6) },
		password: { required, minLength: minLength(6) },
	},
	watch: {
		password(val) {
			val.length === 0
				? (this.passIsActive = false)
				: (this.passIsActive = true);
		},
		email(val) {
			val.length === 0
				? (this.emailIsActive = false)
				: (this.emailIsActive = true);
		},
		login(val) {
			val.length === 0
				? (this.loginIsActive = false)
				: (this.loginIsActive = true);
		},
	},
	methods: {
		async submitHandler() {
			if (this.$v.$invalid) {
				this.$v.$touch();
				return;
			}
			const formData = {
				login: this.login,
				email: this.email,
				password: this.password,
			};

			try {
				const res = await this.$store.dispatch("register", formData);
				this.$router.push('/markets')
			} catch (e) {
				console.log("ERROR!!!", e);
			}
		},
	},
	mounted() {},
};
